import React, { Component } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useEffect, useState } from "react";
;
import { useForm } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import UserProfile from "components/UserProfile/UserProfile";
import { useHistory } from "react-router-dom";

import logo from "assets/img/logo-color.png";
import background   from "assets/img/trucks.jpg";


function Logout() {
    const history = useHistory();
    var doLogout = async function()
    {
        
        await localStorage.removeItem("user");
        history.push('/login');
        
    }
    useEffect(() => {
        doLogout();
        
    }, []);
    
    return (
        <>
        
        </>
        )
}
    
export default Logout;
    